// Keep in sync with app/lib/enums/distributor_product_mapping_status.py
const DistributorProductMappingStatus = {
  ALL: 'all',
  MAPPED: 'mapped',
  UNMAPPED: 'unmapped',
};

const DistributorProductMappingTabs = [
  { value: DistributorProductMappingStatus.ALL, label: 'All Products' },
  { value: DistributorProductMappingStatus.MAPPED, label: 'Mapped' },
  { value: DistributorProductMappingStatus.UNMAPPED, label: 'Unmapped' },
];

export { DistributorProductMappingStatus, DistributorProductMappingTabs };
